import React from 'react';
import { Flex, Text } from "@chakra-ui/react";
import { UnitAvailabilityPropTypes } from "./UnitAvailabilityPropTypes";
import { localisable } from "../../generic/localisable";
import { RenderUnitAvailabilityTable } from "./RenderUnitAvailabilityTable";
import { MAIN_HEADER_PROPS, TAB_HEADER_PROPS } from "./constants";

export const UnitAvailability = ({ permissions, unitTypeData = [] }: UnitAvailabilityPropTypes.IUnitAvailabilityProps) => {
    const { title, pageTitle } = permissions || {};
    return (
        <Flex
            justifyContent='center'
            color='text.grey'
            padding='16px'
            w='100%'
            maxW={{ sm: '720px', md: '1092px' }}
        >
            <Flex direction='column' maxW={'1092px'} gap='16px' w='100%'>
                {/* <Text
                    {...TAB_HEADER_PROPS}
                    textAlign='center'>
                    {pageTitle || localisable.storageUnits}
                </Text> */}
                <Text
                    {...MAIN_HEADER_PROPS}
                    textAlign='center'
                >
                    {title || localisable.unitAvailability}
                </Text>
                <RenderUnitAvailabilityTable permissions={permissions} unitTypeData={unitTypeData} />
            </Flex>
        </Flex >
    )
}